'use client';

import { createContext } from 'react';

import { StockItemContext, StockItemDrawerType } from '../../../elements/StockItemTypes';

export interface StockItemCardContextType {
    stockItemContext: StockItemContext;
    drawerContext?: StockItemDrawerType;
}

const StockItemCardContext = createContext<StockItemCardContextType>({
    stockItemContext: StockItemContext.SEARCH,
    drawerContext: StockItemDrawerType.ALT_VERSIONS,
});

export const StockItemCardProvider = StockItemCardContext.Provider;

export default StockItemCardContext;
